import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import TeamPage from '@/pages/team/page';
import NewsPage from '@/pages/news/page';
import LinksPage from '@/pages/links/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/news', element: <NewsPage /> },
  { path: '/forums', element: <HomePage /> },
  { path: '/links', element: <LinksPage /> },
  { path: '/team', element: <TeamPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
